module.exports = "/_next/static/images/034e8c41542bdcf0615ef76809690008-security.jpg.webp";